<div class="mainContainer">
    <div class="filter_show">
        <h2 class="log_track">Mess Inventory Details</h2>
    </div>
    <div class="mess-box">
        <div class="icon_flex">
            <p class="stock_title">Stock Date<span style="color: red;">*</span> :</p>
            <input matInput [matDatepicker]="mydate" [min]="yesterday" [max]="current" (click)="mydate.open()"
                (dateChange)="onStockDateChange($event)" class="form-control form-date" placeholder="Stock Date" />
            <mat-datepicker-toggle matSuffix [for]="mydate" class="datepic">
            </mat-datepicker-toggle>
            <mat-datepicker #mydate></mat-datepicker>
            <p class="stock_title">Mess/Kitchen<span style="color: red;">*</span> :</p>

            <div class="dropdown">
                <a class="btn  dropdown-toggle custom-dropdown" role="button" data-bs-toggle="dropdown"
                    aria-expanded="false" (click)="focusSearchInput()">
                    <ng-container>
                        <span class="dropdown-label">{{ selectedBuildingName ? selectedBuildingName : 'Select Kitchen
                            Type' }}
                        </span>
                    </ng-container>
                </a>
                <ul class="dropdown-menu campus-details">
                    <li class="d-flex align-items-center">
                        <input type="text" class="form-control form-search" placeholder="Search..." #searchInputcampus
                            (keyup)="campusSearch($event)" [(ngModel)]="campusQuery" />
                    </li>
                    <li class="list_campus">
                        <ng-container *ngFor="let data of filteredCampusDetails;  let i = index">
                            <ul class="overall_Detail" (click)="selectCampus(data?.buildingName,data?.buildingId)"
                                [class.selected]="selectedBuildingID===data?.buildingId">
                                <li class="campus_right"> {{ i + 1 }} ) {{data?.buildingName}}</li>
                                <li>
                                    <span *ngIf="selectedBuildingID===data?.buildingId"><i
                                            class="fa fa-check right_check"></i></span>
                                </li>
                            </ul>
                        </ng-container>
                    </li>
                </ul>
            </div>

            <!-- <p class="type_meals">Inventory Type<span style="color: red;">*</span>:</p>
            <select class="cctv_size" id="" [(ngModel)]="MealsType" (change)="onstudentMeals($event)">
                <option value="" class="select" selected disabled hidden>Select</option>
                <option *ngFor="let item of mealsList" [value]="item.mealsTypeId">
                    {{item.mealsType}}
                </option>
            </select> -->

            <p class="search_title">Search :</p>
            <input type="text" name="" id="" placeholder="Search" (input)="onfilterChange($event)"
                class="form-control search_input">
        </div>

        <!-- MESS-INVENTORY-TABLE --->

        <div class="content" style="width: 100%; height: 50%;">
            <ag-grid-angular style="width: 100%; height: 500px;" [rowData]="rowData"
                [pinnedTopRowData]="pinnedTopRowData" [columnDefs]="colDefs" [defaultColDef]="defaultColDef"
                (cellValueChanged)="onCellValueChanged($event)" [suppressRowClickSelection]="true"
                [rowSelection]="'multiple'" [suppressCellFocus]="false" [suppressHeaderFocus]="true" [rowHeight]="45"
                [quickFilterText]="quickFilter" />
        </div>

        <div class="submit">
            <button class="sub_btn" (click)="submit()">Submit</button>
        </div>
    </div>
</div>

<!-- ================================ loader ======================-->
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>